import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.event
 * @constructor
 */
export class EventQueryModel extends BaseModel {
  /**
   * @param {number} [startAfterSequenceId]
   * @param {string} [createdAtStart] An ISO 8601 Date Time Stamp
   * @param {string} [resourceId]
   * @param {string} [relatedResourceId]
   * @param {Array<string>} [eventTypes]
   */
  constructor({
    startAfterSequenceId,
    createdAtStart,
    resourceId,
    relatedResourceId,
    eventTypes,
  }) {
    super()

    /** @type {number} */
    if (!this.isUndefined(startAfterSequenceId)) this.startAfterSequenceId = startAfterSequenceId

    /** @type {string} */
    if (!this.isUndefined(createdAtStart)) this.createdAtStart = createdAtStart

    /** @type {string} */
    if (!this.isUndefined(resourceId)) this.resourceId = resourceId

    /** @type {string} */
    if (!this.isUndefined(relatedResourceId)) this.relatedResourceId = relatedResourceId

    /** @type {Array<string>} */
    if (!this.isUndefined(eventTypes)) this.eventTypes = eventTypes
  }
}
